/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
import AddIcon from '@material-ui/icons/Add'
import { Grid, Button } from '@material-ui/core'
import { Modal36 } from '../../Modals/ModalSec3/Modal36'
import swal from 'sweetalert'
import { deleteAssestLossClimate } from '../../../../../services/Elegibilidad/delete'
import { Modal36Edit } from '../../Modals/ModalSec3Edit/Modal36Edit'
import { getAssetsByForm } from '../../../../../services/Elegibilidad/get'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { useEligibility } from '../../../../../context/EligibilityContext'
import NumberFormat from 'react-number-format'

const Table36 = ({ idElegibilityForm }) => {
  const [state, dispatch] = useEligibility()
  const [open, setOpen] = useState(false)
  const [openEdit, setOpenEdit] = useState(false)
  const [tableData, setTableData] = useState([])
  const [body, setBody] = useState({})
  const [validateTable, setValidateTable] = useState(true)

  const getDataTable = async () => {
    try {
      const response = await getAssetsByForm(idElegibilityForm)
      if (response.Success) {
        setTableData(response.Data)
        if (response.Data.length >= 5) {
          setValidateTable(false)
        } else {
          setValidateTable(true)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleDelete = async (id) => {
    try {
      const response = await deleteAssestLossClimate(id)
      if (response.Success) {
        swal({
          title: '¡Registro eliminado exitosamente!',
          icon: 'success',
        })
        getDataTable()
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      state.step === 3 &&
      idElegibilityForm !== undefined &&
      idElegibilityForm !== null
    ) {
      getDataTable()
    }
  }, [state.step])

  const columns = [
    {
      title: 'Activo físico',
      field: 'PhysicalAsset',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Cantidad de activos',
      field: 'AssetsNumber',
      filtering: false,
      align: 'center',
      render: (expense) => (
        <NumberFormat
          value={expense.AssetsNumber}
          thousandSeparator={true}
          decimalScale={0}
          displayType={'text'}
          isNumericString={true}
        />
      ),
    },
    {
      title: 'Daño del activo',
      field: 'AssetDamage',
      align: 'center',
      grouping: false,
      filtering: false,
    },

    {
      title: 'Monto',
      field: 'AmountLocalCurrency',
      align: 'center',
      filtering: false,
      render: (expense) => (
        <NumberFormat
          value={expense.AmountLocalCurrency}
          thousandSeparator={true}
          decimalScale={2}
          displayType={'text'}
          isNumericString={true}
          fixedDecimalScale
        />
      ),
    },
    {
      title: 'Monto en dólares',
      field: 'AmountDollars',
      align: 'center',
      filtering: false,
      render: (expense) => (
        <NumberFormat
          value={expense.AmountDollars}
          thousandSeparator={true}
          decimalScale={2}
          displayType={'text'}
          isNumericString={true}
          fixedDecimalScale
        />
      ),
    },
    {
      title: 'Evento climático',
      field: 'ClimaticEvent',
      align: 'center',
      filtering: false,
    },
  ]
  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={tableData}
            actions={[
              validateTable
                ? {
                    icon: () => (
                      <Button
                        variant="contained"
                        color="success"
                        style={{ backgroundColor: '#27C27D', color: '#FFFFFF' }}
                        startIcon={<AddIcon style={{ color: 'white' }} />}
                      >
                        Agregar activo
                      </Button>
                    ),
                    tooltip: 'Agregar',
                    position: 'toolbar',
                    onClick: () => {
                      setOpen(true)
                    },
                  }
                : null,
              {
                icon: () => <EditIcon style={{ color: '#0d53ad' }} />,
                tooltip: 'Editar',
                onClick: (event, rowData) => {
                  setOpenEdit(true)
                  setBody(rowData)
                },
              },
              {
                icon: () => <DeleteIcon style={{ color: 'red' }} />,
                tooltip: 'Eliminar registro',
                onClick: (event, rowData) => {
                  swal({
                    title: '¿Está seguro de eliminar el registro?',
                    icon: 'warning',
                    buttons: ['No', 'Si'],
                    dangerMode: true,
                  }).then(function (isConfirm) {
                    if (isConfirm) {
                      handleDelete(rowData.IdAssetLossClimate)
                    }
                  })
                },
              },
            ]}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',

              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'left',
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),

              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
            icons={{ Add: () => <AddIcon /> }}
          />
        </Grid>
      </Grid>
      <Modal36 open={open} setOpen={setOpen} getDataTable={getDataTable} />
      <Modal36Edit
        open={openEdit}
        setOpen={setOpenEdit}
        body={body}
        setBody={setBody}
        getDataTable={getDataTable}
      />
    </div>
  )
}

export default React.memo(Table36)
